import { render, staticRenderFns } from "./JuniperClientUpgradeCard.vue?vue&type=template&id=f8319e46&scoped=true&"
import script from "./JuniperClientUpgradeCard.vue?vue&type=script&lang=js&"
export * from "./JuniperClientUpgradeCard.vue?vue&type=script&lang=js&"
import style0 from "./JuniperClientUpgradeCard.vue?vue&type=style&index=0&id=f8319e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8319e46",
  null
  
)

export default component.exports